import { DesignerMinimumRequirements } from "../designer-minimum-requirements";
import { PopupContainer } from "../popup";

export const DesignerRequirementsPopup = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  if (!visible) return null;
  return (
    <PopupContainer onClose={onClose} title="Minimum Requirements">
      <DesignerMinimumRequirements />
    </PopupContainer>
  );
};
